import {
  faWordpressSimple,
  faReact,
  faNodeJs,
  faShopify,
  faFontAwesomeLogoFull,
} from "@fortawesome/free-brands-svg-icons";
import {
  faLaptopCode,
  faMobileAlt,
  faCheck,
  faFileVideo,
  faShoppingCart,
  faRectangleAd,
} from "@fortawesome/free-solid-svg-icons";

let ServicesData = [
  {
    serviceID: 1,
    serviceName: "Modern Website Development",
    serviceIcon: faLaptopCode,
  },

  {
    serviceID: 2,
    serviceName: "WordPress Development",
    serviceIcon: faWordpressSimple,
  },

  {
    serviceID: 3,
    serviceName: "Ecommerce Site Development",
    serviceIcon: faShoppingCart,
  },

  {
    serviceID: 4,
    serviceName: "Web Application Development (ReactJS)",
    serviceIcon: faReact,
  },

  {
    serviceID: 5,
    serviceName: "Responsive Static Site Development",
    serviceIcon: faMobileAlt,
  },

  {
    serviceID: 6,
    serviceName: "API Development (Node.js,Express.js)",
    serviceIcon: faNodeJs,
  },

  {
    serviceID: 7,
    serviceName: "Shopify Site Development",
    serviceIcon: faShopify,
  },

  {
    serviceID: 8,
    serviceName: "Logo & Brochure Designing (Photoshop/CorelDraw)",
    serviceIcon: faFontAwesomeLogoFull,
  },

  {
    serviceID: 9,
    serviceName: "Site Speed Optimization",
    serviceIcon: faCheck,
  },

  {
    serviceID: 10,
    serviceName: "Digital Marketing",
    serviceIcon: faRectangleAd,
  },
];

export default ServicesData;
